import { useEffect } from "react";
import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase/firebase";
import { Routes, Route } from "react-router-dom";

import { Home, Login, Playlist } from "./pages/index";
import ProtectedRoute from "./routes/ProtectedRoute";
import GuestOnlyRoute from "./routes/GuestOnlyRoute";

function App() {
  useEffect(() => {
    logEvent(analytics, "home_page_load", {
      label: "User first load enter the site",
      screen: "Home",
    });
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route
        path="/login"
        element={
          <GuestOnlyRoute>
            <Login />
          </GuestOnlyRoute>
        }
      />
      {/* <Route
        path="/news"
        element={
          <ProtectedRoute>
            <News />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="/playlist"
        element={
          <ProtectedRoute>
            <Playlist />
          </ProtectedRoute>
        }
      />
      <Route
        path="/playlist/:albumId"
        element={
          <ProtectedRoute>
            <Playlist />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
